import { StarIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import { createEarlyAdopterHandler } from '@/utils/earlyAdopterInterceptor';

const PricingHero = () => {
  const { openModal } = useEarlyAdopter();
  
  return (
    <div className="relative py-16 px-4 overflow-hidden">
      {/* Warm gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/8 via-circle-secondary/5 to-primary/8"></div>
      <div className="absolute top-10 left-1/4 w-72 h-72 bg-circle-secondary/15 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-1/4 w-72 h-72 bg-primary/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-12">
          {/* Headline */}
          <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Choose Your <span className="text-primary">Home Operating System</span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-8">
            Whether you're building independence for yourself or supporting someone you love, SeniorThrive grows with you. Select your starting point below to begin.
          </p>
          
          {/* Early Access Card */}
          <Card className="max-w-3xl mx-auto bg-gradient-to-br from-primary/10 to-circle-secondary/10 border-primary/20 shadow-lg">
            <CardContent className="pt-8 pb-8">
              <div className="flex items-center justify-center gap-2 mb-4">
                <StarIcon className="w-5 h-5 text-amber-500 fill-amber-500" />
                <h3 className="text-xl font-semibold text-foreground">Early Access Now Open</h3>
                <StarIcon className="w-5 h-5 text-amber-500 fill-amber-500" />
              </div>
              <p className="text-muted-foreground mb-4 text-lg">
                SeniorThrive is currently in limited release. Join the waitlist to receive priority access as we expand availability to more households.
              </p>
              <p className="text-sm text-muted-foreground/80 italic mb-6">
                No commitment. No payment required.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  size="lg" 
                  variant="default" 
                  className="bg-primary hover:bg-primary/90 text-lg px-8 py-6 shadow-md"
                  onClick={createEarlyAdopterHandler(openModal, 'Pricing Hero - Request Early Access')}
                >
                  Request Early Access
                  <ArrowRightIcon className="w-5 h-5 ml-2" />
                </Button>
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="text-lg px-8 py-6"
                  onClick={() => document.getElementById('feature-comparison')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Compare Plans
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PricingHero;
